module.exports = __webpack_public_path__ + "static/media/tonic.de84cc05.jpg";